var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('let-it-snow',_vm._b({attrs:{"show":true}},'let-it-snow',_vm.snowConf,false)),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }